import React from 'react'
import { Link } from 'react-router-dom'
import { SegmentedControl } from './controls/SegmentedControl'
import type { TargetShape } from '../types'

interface HeaderProps {
  targetShape?: TargetShape
  onShapeChange?: (shape: TargetShape) => void
  page: 'editor' | 'gallery'
}

const SHAPE_OPTIONS = [
  { label: 'Box', value: 'box' as TargetShape },
  { label: 'Circle', value: 'circle' as TargetShape },
  { label: 'Card', value: 'card' as TargetShape },
]

export function Header({ targetShape, onShapeChange, page }: HeaderProps) {
  return (
    <header className="h-14 border-b border-gray-200 bg-white flex items-center justify-between px-4 shrink-0">
      <div className="flex items-center gap-3">
        <Link to="/motion-playground" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
          <div className="w-7 h-7 bg-gray-900 rounded-lg flex items-center justify-center">
            <span className="text-white text-xs font-bold">N</span>
          </div>
          <span className="text-sm font-semibold text-gray-900">Motion Playground</span>
        </Link>
      </div>

      <div className="w-56">
        {page === 'editor' && targetShape && onShapeChange ? (
          <SegmentedControl
            options={SHAPE_OPTIONS}
            value={targetShape}
            onChange={onShapeChange}
          />
        ) : (
          <span className="block text-center text-sm font-medium text-gray-600">Animation Examples</span>
        )}
      </div>

      <div className="flex items-center gap-3">
        {page === 'editor' ? (
          <Link
            to="/motion-playground"
            className="text-xs text-gray-500 hover:text-gray-800 transition-colors font-medium"
          >
            Gallery
          </Link>
        ) : (
          <Link
            to="/motion-playground/sandbox"
            className="text-xs text-gray-500 hover:text-gray-800 transition-colors font-medium"
          >
            Sandbox
          </Link>
        )}
      </div>
    </header>
  )
}
